import { HelpCircle } from '@untitled-ui/icons-react';
import React from 'react';

import { Tooltip, TooltipProps } from '@myhealth-raccoon/components';

export function Hint(props: TooltipProps) {
    return (
        <Tooltip attachmentPoint="top" className="relative top-0.5 inline-block" {...props}>
            <HelpCircle className="h-4 w-4 text-gray-400" />
        </Tooltip>
    );
}
